import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from 'src/reducers';
import styles from './nav-bar.module.scss';
import { isSystem } from 'src/utils/auth-utils';
import {
  EDIT_TIMESHEET_PERMISSION,
  isAuthorizedToHandleCapability,
  VIEW_ANAGRAPHIC_PERMISSION,
  VIEW_CAPABILITIES_PERMISSION,
  VIEW_COMMISSION_PERMISSION,
  VIEW_TIMESHEETS_PERMISSION,
} from '../../../utils/capability-utils';

const NavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { user } = useAppSelector(state => state.authentication);

  const isSelected = (path: string) => location.pathname === path;

  if (!user) {
    return <></>;
  }

  return (
    <div className={styles.navBarContainer}>
      <div className={styles.redirectWrapper}>
        {(isSystem(user.authority.name as string) || isAuthorizedToHandleCapability(user, VIEW_ANAGRAPHIC_PERMISSION)) && (
          <Link to="/employees" className={`${styles.redirect} ${isSelected('/employees') ? styles.selected : ''}`}>
            Dipendenti
          </Link>
        )}
        {(isSystem(user.authority.name as string) || isAuthorizedToHandleCapability(user, VIEW_CAPABILITIES_PERMISSION)) && (
          <Link to="/profiles" className={`${styles.redirect} ${isSelected('/profiles') ? styles.selected : ''}`}>
            Profili e autorizzazioni
          </Link>
        )}
        {isSystem(user.authority.name as string) || isAuthorizedToHandleCapability(user, VIEW_TIMESHEETS_PERMISSION) ? (
          <Link to="/timesheets" className={`${styles.redirect} ${isSelected('/timesheets') ? styles.selected : ''}`}>
            Rapportini
          </Link>
        ) : isAuthorizedToHandleCapability(user, EDIT_TIMESHEET_PERMISSION) ? (
          <div
            onClick={() => navigate(`/timesheet/${user?.id}`)}
            className={`${styles.redirect} ${isSelected(`/timesheet/${user?.id}`) ? styles.selected : ''}`}
          >
            Rapportini
          </div>
        ) : null}
        {(isSystem(user.authority.name as string) || isAuthorizedToHandleCapability(user, VIEW_COMMISSION_PERMISSION)) && (
          <Link to="/commissions" className={`${styles.redirect} ${isSelected('/commissions') ? styles.selected : ''}`}>
            Commesse
          </Link>
        )}
      </div>
    </div>
  );
};

export default NavBar;
